import React from 'react';
import PropTypes from 'prop-types';

import {
  caseBlockCard,
  caseChangeRipleyCard,
  casePayAccount,
  caseRipleyPtosGo,
  caseInsurancesRipley,
  caseExtendCompanyGiftCard,
} from '../Messages';
import BallotInvoiceCopy from './BallotInvoiceCopy';

import OnlyMessageBody from '../mobile/OnlyMessageBody';
import FormErrorInPage from './FormErrorInPage';
import ExtendGiftCard from './ExtendGiftCard';
import GiftCardProblem from './GiftCardProblem';
import ClubsGeneralProblems from './ClubsGeneralProblems';

const FormList = ({ ...props }) => {
  const { motiveId, type } = props;

  return (
    <React.Fragment>
      {motiveId === 25 && <OnlyMessageBody message={caseBlockCard()} />}
      {motiveId === 12 && <OnlyMessageBody message={caseChangeRipleyCard()} />}
      {motiveId === 24 && <OnlyMessageBody message={casePayAccount} />}
      {motiveId === 20 && <OnlyMessageBody message={caseRipleyPtosGo()} />}
      {motiveId === 23 && <OnlyMessageBody message={caseInsurancesRipley()} />}
      {motiveId === 18 && <BallotInvoiceCopy />}
      {motiveId === 33 && (
        <FormErrorInPage
          motiveId={motiveId}
          type={type}
          title="Descripción del error"
          idComplement="ErrorPage"
        />
      )}
      {motiveId === 17 && (
        <FormErrorInPage
          motiveId={motiveId}
          type={type}
          title="Descripción del inconveniente"
          idComplement="PurchaseError"
        />
      )}
      {motiveId === 31 && <ExtendGiftCard type={type} motiveId={motiveId} />}
      {motiveId === 32 && (
        <OnlyMessageBody message={caseExtendCompanyGiftCard} />
      )}
      {motiveId === 36 && <GiftCardProblem type={type} motiveId={motiveId} />}
      {motiveId === 'general-clubs' && <ClubsGeneralProblems type={type} />}
    </React.Fragment>
  );
};

FormList.propTypes = {
  motiveId: PropTypes.number,
  type: PropTypes.number,
};

export default FormList;
